import React, { useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const PRESETS = [
  { k: "xs", l: "ÇOK DAR", v: 16 },
  { k: "sm", l: "DAR", v: 20 },
  { k: "md", l: "ORTA", v: 26 },
  { k: "lg", l: "GENİŞ", v: 34 },
  { k: "xl", l: "ÇOK GENİŞ", v: 44 },
];

export const getRowH = () => { const v = parseInt(localStorage.getItem("mwcrm_rowh")); return Number.isFinite(v) ? v : 16; };

export default function RowSizeSettings() {
  const { isAdmin } = useAuth();
  const [rowH, setRowH] = useState(getRowH);
  const saveFirm = async () => {
    try { await api.put("/tenant/ui", { data: { rowh: rowH } }); toast.success("TÜM FİRMAYA UYGULANDI"); }
    catch (e) { toast.error(e.response?.data?.detail || "KAYDEDİLEMEDİ"); }
  };
  const apply = (v) => {
    const n = v ? Math.min(44, Math.max(12, v)) : 0;
    setRowH(n);
    localStorage.setItem("mwcrm_rowh", String(n));
    window.dispatchEvent(new Event("mw-rowh"));
  };
  return (
    <div data-testid="rowsize-settings" className="rounded-xl border border-slate-800 bg-slate-900/60 p-5">
      <h2 className="text-lg font-bold text-white">SATIR ÖLÇÜSÜ (TÜM TABLOLAR)</h2>
      <p className="mt-1 text-xs text-slate-400">MÜŞTERİLER VE DİĞER LİSTELERDE SATIR YÜKSEKLİĞİ. UZUN METİNLER TEK SATIRDA KESİLİR.</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button key={p.k} data-testid={`rowsize-${p.k}`} onClick={() => apply(p.v)}
            className={`rounded-lg px-4 py-2 text-sm font-semibold ${rowH === p.v ? "bg-emerald-500/20 text-emerald-300 ring-1 ring-emerald-500/40" : "bg-slate-800 text-slate-300 hover:bg-slate-700"}`}>
            {p.l} <span className="text-xs opacity-70">{p.v}px</span>
          </button>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-3">
        <span className="text-xs font-semibold text-slate-400">ÖZEL:</span>
        <input data-testid="rowsize-slider" type="range" min="12" max="44" value={rowH || 36} onChange={(e) => apply(parseInt(e.target.value))} className="w-60 cursor-pointer accent-emerald-500" />
        <span data-testid="rowsize-value" className="text-sm font-semibold text-slate-300">{rowH ? rowH + "px" : "NORMAL"}</span>
        <button data-testid="rowsize-reset" onClick={() => apply(0)} className="rounded-md bg-slate-800 px-3 py-1 text-xs font-semibold text-slate-300 hover:bg-slate-700">NORMALE DÖN</button>
      </div>
      {isAdmin && (
        <div data-testid="rowsize-firm" className="mt-6 border-t border-slate-800 pt-4">
          <h3 className="text-sm font-bold text-white">FİRMA GENELİ (TÜM KULLANICILAR)</h3>
          <p className="mt-1 text-xs text-slate-400">SEÇİLİ SATIR ÖLÇÜSÜ FİRMADAKİ HERKESE UYGULANIR.</p>
          <div className="mt-3 flex flex-wrap items-center gap-3">
            <button data-testid="rowsize-firm-save" onClick={saveFirm} className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700">TÜM FİRMAYA UYGULA ({rowH ? rowH + "px" : "NORMAL"})</button>
          </div>
        </div>
      )}
    </div>
  );
}
